import type { RelatedProductRenderer } from '@zoomit/editor';
import { Flex } from '@zoomit/primitives';
import type { ProductListItemType } from '@zoomit/web-kit';
import { isMobile, ProductListItemDesktop, ProductListItemMobile } from '@zoomit/web-kit';

import { useProductPriceQuery } from '../../../hooks/useProductPrice';

type Props = {
  blockData: RelatedProductRenderer;
};
const FeaturedProductsList = (props: Props) => {
  const { blockData } = props;

  const productsIds = blockData.products.map((p) => p.id);

  const { productQuery, findPrice } = useProductPriceQuery({ productsIds });
  const { data: prices, isLoading } = productQuery;

  return (
    <Flex flexDirection="column" gap={0.8}>
      {blockData.products.map((data) =>
        isMobile ? (
          <ProductListItemMobile
            {...(data as ProductListItemType)}
            isFeatured
            showFeaturedVariant
            minPrice={+findPrice(data.id, prices)}
            isLoadingPrice={isLoading}
          />
        ) : (
          <ProductListItemDesktop
            key={data.id}
            {...(data as ProductListItemType)}
            isFeatured
            showFeaturedVariant
            size="large"
            minPrice={+findPrice(data.id, prices)}
            isLoadingPrice={isLoading}
          />
        ),
      )}
    </Flex>
  );
};

export default FeaturedProductsList;
